module.exports = __webpack_public_path__ + "img/shipinfomation.6a30793d.png";